<template>
  <div>
    <h4 class="subtitle-1 mb-1 d-block" v-if="label && label.length > 0">
      {{ label }}
    </h4>
    <v-textarea
      :value="value"
      :rules="rules"
      @keyup="$emit('update:value', $event.target.value)"
      validate-on-blur
      auto-grow
      outlined
    ></v-textarea>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  data() {
    return {};
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
});
</script>
